
class ShippingInfo {
  constructor(){
    this.overridenShippingSchedule = {
      us: {
        '2024-11-23': {standard: 'Nov 30 - Dec 3', expedited: 'Nov 29', twoDay: 'Nov 27', overnight: 'Nov 26'},
        '2024-11-24': {standard: 'Nov 30 - Dec 3', expedited: 'Nov 29', twoDay: 'Nov 27', overnight: 'Nov 26'},
        '2024-11-25': {standard: 'Nov 30 - Dec 3', expedited: 'Nov 29', twoDay: 'Nov 27', overnight: 'Nov 26'},
        '2024-11-26': {standard: 'Dec 2 - Dec 4', expedited: 'Nov 29 - Nov 30', twoDay: 'Nov 28', overnight: 'Nov 27'},
        '2024-11-27': {standard: 'Dec 3 - Dec 5', expedited: 'Dec 2 - Dec 3', twoDay: 'Nov 29', overnight: 'Nov 28'},
        '2024-11-28': {standard: 'Dec 6 - Dec 7', expedited: 'Dec 4 - Dec 5', twoDay: 'Dec 03', overnight: 'Nov 30'},
        '2024-11-29': {standard: 'Dec 6 - Dec 7', expedited: 'Dec 4 - Dec 5', twoDay: 'Dec 03', overnight: 'Nov 30'},
        '2024-11-30': {standard: 'Dec 7 - Dec 9', expedited: 'Dec 5 - Dec 6', twoDay: 'Dec 04', overnight: 'Dec 03'},
        '2024-12-01': {standard: 'Dec 7 - Dec 9', expedited: 'Dec 5 - Dec 6', twoDay: 'Dec 04', overnight: 'Dec 03'},
        '2024-12-02': {standard: 'Dec 7 - Dec 9', expedited: 'Dec 5 - Dec 6', twoDay: 'Dec 04', overnight: 'Dec 03'},
        '2024-12-03': {standard: 'Dec 9 - Dec 10', expedited: 'Dec 6 - Dec 7', twoDay: 'Dec 05', overnight: 'Dec 04'},
        '2024-12-04': {standard: 'Dec 10 - Dec 11', expedited: 'Dec 7 - Dec 9', twoDay: 'Dec 06', overnight: 'Dec 05'},
        '2024-12-05': {standard: 'Dec 11 - Dec 12', expedited: 'Dec 9 - Dec 10', twoDay: 'Dec 07', overnight: 'Dec 06'},
        '2024-12-06': {standard: 'Dec 12 - Dec 13', expedited: 'Dec 11 - Dec 12', twoDay: 'Dec 10', overnight: 'Dec 07'},
        '2024-12-07': {standard: 'Dec 14 - Dec 16', expedited: 'Dec 12 - Dec 13', twoDay: 'Dec 11', overnight: 'Dec 10'},
        '2024-12-08': {standard: 'Dec 14 - Dec 16', expedited: 'Dec 12 - Dec 13', twoDay: 'Dec 11', overnight: 'Dec 10'},
        '2024-12-09': {standard: 'Dec 14 - Dec 16', expedited: 'Dec 12 - Dec 13', twoDay: 'Dec 11', overnight: 'Dec 10'},
        '2024-12-10': {standard: 'Dec 16 - Dec 17', expedited: 'Dec 13 - Dec 14', twoDay: 'Dec 12', overnight: 'Dec 11'},
        '2024-12-11': {standard: 'Dec 17 - Dec 18', expedited: 'Dec 14 - Dec 16', twoDay: 'Dec 13', overnight: 'Dec 12'},
        '2024-12-12': {standard: 'Dec 18 - Dec 19', expedited: 'Dec 17 - Dec 18', twoDay: 'Dec 14', overnight: 'Dec 13'},
        '2024-12-13': {standard: 'Dec 19 - Dec 20', expedited: 'Dec 18 - Dec 19', twoDay: 'Dec 17', overnight: 'Dec 14'},
        '2024-12-14': {standard: 'Dec 21 - Dec 23', expedited: 'Dec 19 - Dec 20', twoDay: 'Dec 18', overnight: 'Dec 17'},
        '2024-12-15': {standard: 'Dec 21 - Dec 23', expedited: 'Dec 19 - Dec 20', twoDay: 'Dec 18', overnight: 'Dec 17'},
        '2024-12-16': {standard: 'Dec 21 - Dec 23', expedited: 'Dec 19 - Dec 20', twoDay: 'Dec 18', overnight: 'Dec 17'},
        '2024-12-17': {standard: 'Dec 23', expedited: 'Dec 20 - Dec 21', twoDay: 'Dec 19', overnight: 'Dec 18'},
        '2024-12-18': {standard: 'Dec 24', expedited: 'Dec 23', twoDay: 'Dec 20', overnight: 'Dec 19'},
        '2024-12-19': {standard: 'Dec 24', expedited: 'Dec 23', twoDay: 'Dec 21', overnight: 'Dec 20'},
        '2024-12-20': {standard: 'Dec 27', expedited: 'Dec 26', twoDay: 'Dec 24', overnight: 'Dec 21'},
        '2024-12-21': {standard: 'Dec 31', expedited: 'Dec 27', twoDay: 'Dec 26', overnight: 'Dec 24'},
        '2024-12-22': {standard: 'Dec 31', expedited: 'Dec 27', twoDay: 'Dec 26', overnight: 'Dec 24'},
        '2024-12-23': {standard: 'Dec 31', expedited: 'Dec 28', twoDay: 'Dec 26', overnight: 'Dec 24'},
        '2024-12-24': {standard: 'Jan 02 - Jan 04', expedited: 'Dec 31 - Jan 01', twoDay: 'Dec 28', overnight: 'Dec 27'},
        '2024-12-25': {standard: 'Jan 02 - Jan 04', expedited: 'Dec 31 - Jan 01', twoDay: 'Dec 28', overnight: 'Dec 27'},
        '2024-12-26': {standard: 'Jan 02 - Jan 04', expedited: 'Dec 31 - Jan 01', twoDay: 'Dec 28', overnight: 'Dec 27'},
        "2024-12-27":{standard:'Jan 03 - Jan 05', expedited:'Jan 01 - Jan 02', twoDay:'Dec 29', overnight:'Dec 28'},
        "2024-12-28":{standard:'Jan 04 - Jan 06', expedited:'Jan 02 - Jan 03', twoDay:'Dec 30', overnight:'Dec 29'},
        "2024-12-29":{standard:'Jan 05 - Jan 07', expedited:'Jan 03 - Jan 04', twoDay:'Dec 31', overnight:'Dec 30'},
        "2024-12-30":{standard:'Jan 06 - Jan 08', expedited:'Jan 04 - Jan 05', twoDay:'Jan 01', overnight:'Dec 31'},
        "2024-12-31":{standard:'Jan 08 - Jan 10', expedited:'Jan 06 - Jan 07', twoDay:'Jan 03', overnight:'Jan 02'},
        "2025-01-01":{standard:'Jan 09 - Jan 11', expedited:'Jan 07 - Jan 08', twoDay:'Jan 04', overnight:'Jan 03'},
        "2025-01-02":{standard:'Jan 09 - Jan 11', expedited:'Jan 07 - Jan 08', twoDay:'Jan 04', overnight:'Jan 03'},
        "2025-01-03":{standard:'Jan 10 - Jan 12', expedited:'Jan 08 - Jan 09', twoDay:'Jan 05', overnight:'Jan 04'},
        "2025-01-04":{standard:'Jan 11 - Jan 13', expedited:'Jan 09 - Jan 10', twoDay:'Jan 06', overnight:'Jan 05'},
        "2025-01-05":{standard:'Jan 12 - Jan 14', expedited:'Jan 10 - Jan 11', twoDay:'Jan 07', overnight:'Jan 06'},
        "2025-01-06":{standard:'Jan 13 - Jan 15', expedited:'Jan 11 - Jan 12', twoDay:'Jan 08', overnight:'Jan 07'},
        "2025-01-07":{standard:'Jan 14 - Jan 16', expedited:'Jan 12 - Jan 13', twoDay:'Jan 09', overnight:'Jan 08'},
        "2025-01-08":{standard:'Jan 15 - Jan 17', expedited:'Jan 13 - Jan 14', twoDay:'Jan 10', overnight:'Jan 09'},
        "2025-01-09":{standard:'Jan 16 - Jan 18', expedited:'Jan 14 - Jan 15', twoDay:'Jan 11', overnight:'Jan 10'},
        "2025-01-10":{standard:'Jan 17 - Jan 19', expedited:'Jan 15 - Jan 16', twoDay:'Jan 12', overnight:'Jan 11'},
        "2025-11-24":{standard:'Dec 02 - Dec 04', expedited:'Nov 30 - Dec 01', twoDay:'Nov 28', overnight:'Nov 26'},
        "2025-11-25":{standard:'Dec 02 - Dec 04', expedited:'Nov 30 - Dec 01', twoDay:'Nov 28', overnight:'Nov 26'},
        "2025-11-26":{standard:'Dec 03 - Dec 05', expedited:'Nov 31 - Dec 02', twoDay:'Nov 28', overnight:'Nov 28'},
        "2025-11-27":{standard:'Dec 04 - Dec 06', expedited:'Dec 01 - Dec 03', twoDay:'Nov 30', overnight:'Nov 29'},
        "2025-12-12":{standard:'Dec 19', expedited:'Dec 18', twoDay:'Dec 16', overnight: "Dec 13"},
        "2025-12-13":{standard:'Dec 22', expedited:'Dec 19', twoDay:'Dec 17', overnight: "Dec 16"},
        "2025-12-14":{standard:'Dec 22', expedited:'Dec 19', twoDay:'Dec 17', overnight: "Dec 16"},
        "2025-12-15":{standard:'Dec 22', expedited:'Dec 19', twoDay:'Dec 17', overnight: "Dec 16"},
        "2025-12-16":{standard:'Dec 23', expedited:'Dec 20', twoDay:'Dec 18', overnight: "Dec 17"},
        "2025-12-17": {standard:"Dec 23",expedited:"Dec 22",twoDay:"Dec 29",overnight:"Dec 18"},
        "2025-12-18": {standard:"Dec 26",expedited:"Dec 23",twoDay:"Dec 20",overnight:"Dec 19"},
        "2025-12-19": {standard:"Dec 29",expedited:"Dec 26",twoDay:"Dec 23",overnight:"Dec 20"},
        "2025-12-20": {standard:"Dec 30",expedited:"Dec 27",twoDay:"Dec 24",overnight:"Dec 23"},
        "2025-12-21": {standard:"Dec 30",expedited:"Dec 27",twoDay:"Dec 24",overnight:"Dec 23"},
        "2025-12-22": {standard:"Dec 30",expedited:"Dec 27",twoDay:"Dec 24",overnight:"Dec 23"},
        "2025-12-23": {standard:"Dec 31",expedited:"Dec 29",twoDay:"Dec 26",overnight:"Dec 24"},
        "2025-12-24": {standard:"Jan 03",expedited:"Jan 01",twoDay:"Dec 28",overnight:"Dec 27"},
        
      },
      canada: {
      
      },
      international: {
        
      }
    }
  }
  get_formatted_date (date) {
    console.log(date)
    let year = date.getYear() - 100 + 2000;
    console.log("Current Year: " + year);
    let month = String(date.getMonth() + 1).padStart(2,'0');
    let day = String(date.getDate()).padStart(2,'0');
    return `${year}-${month}-${day}`;
  }
  
  get_shipping_date(offset, date){
      const offsetDate = new Date(date);

      //Adding offset for business days
      
      let weekday = offsetDate.getDay();
      
      // Add or remove certain days of the week for reasons whenever specified
      const invalid_weekdays = [0,6]
      for(let i = 0; i <= offset; i++){
        if(invalid_weekdays.includes(weekday)){
            offset++;
        }
        weekday = (weekday + 1) % 7;
      }
      offsetDate.setDate(offsetDate.getDate() + offset);
      
      return `${offsetDate.toLocaleString("en", {month: 'short'})} ${String(offsetDate.getDate()).padStart(2, '0')}`;
  }

  get_shipping_info (region, date) {
    console.log("Getting info for " + date + "and " + region)
    

    
    
    const formatted_date = this.get_formatted_date(date);
    if(this.overridenShippingSchedule[region] != undefined){
        if(this.overridenShippingSchedule[region][formatted_date]){
            console.log("Override Taken");
            return this.overridenShippingSchedule[region][formatted_date];
        }
    }
    let result = {}
    console.log(region)
    switch(region){
        case "us":
          // standard 7-9 business days
          // expedited 5-6 business days
          // twoDay 2 business days
          // overnight 1 business day
          result = {standard: `${this.get_shipping_date(7, date)} - ${this.get_shipping_date(9, date)}`, expedited: `${this.get_shipping_date(5, date)} - ${this.get_shipping_date(6, date)}`, twoDay: this.get_shipping_date(2, date), overnight: this.get_shipping_date(1, date)};
          break;
        case "canada":
          result = {standard: ``, expedited: ``};
          break;
        //For international shipping
        case "international":
          result = {standard: ``, expedited: ``};
          break;
    }
    console.log(result);
    return result;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('Shipping Info Initializing...');
  window.shippingInfo = new ShippingInfo();
});

